import { Flex, Text, csx } from '@vtex/admin-ui'
import { FormattedDate, FormattedTime } from 'react-intl'

import type { ColumnParams, GenericPromotion } from 'typings'

export function BeginDate(props: ColumnParams<GenericPromotion>) {
  const {
    item: { beginDate },
  } = props

  return (
    <Flex
      direction="column"
      justify="center"
      className={csx({ height: 'full' })}
    >
      <Text>
        <FormattedDate
          value={beginDate}
          month="short"
          day="2-digit"
          year="numeric"
        />
      </Text>
      <Text tone="secondary">
        <FormattedTime value={beginDate} />
      </Text>
    </Flex>
  )
}
